define(['backbone'], function(backbone) {
    let DesignFaceProcessModel;

    return (DesignFaceProcessModel = backbone.Model.extend(
        {
            idAttribute: 'type',
            defaults: {
                type: null,
                src: null,
                fileId: null,
                sessionId: null
            },

            /**
             * @returns {Array}
             */
            getFoilProcesses: function() {
                return [DesignFaceProcessModel.TYPE_FOIL_SILVER, DesignFaceProcessModel.TYPE_FOIL_GOLD];
            }
        },
        {
            TYPE_REGULAR: 'regular',
            TYPE_SPOT_UV: 'spotUV',
            TYPE_TEXTURE: 'KRE8-3D',
            TYPE_FOIL: 'foil',
            TYPE_FOIL_SILVER: 'foil_silver',
            TYPE_FOIL_GOLD: 'foil_gold'
        }
    ));
});
